'use client';

import React, { useState } from 'react';

export default function CollectionDescription({ collection }) {
  const [more, setMore] = useState(false);

  return (
    <div className='flex w-full flex-row items-end justify-end'>
      <p
        className='mt-[6px] text-sm dark:text-jacarta-200'
        style={
          !more
            ? {
                display: '-webkit-box',
                overflow: 'hidden',
                'text-overflow': 'ellipsis',
                'line-clamp': '2',
                '-webkit-line-clamp': '2',
                '-webkit-box-orient': 'vertical',
              }
            : {
                overflowY: 'auto',
                maxHeight: '50px',
              }
        }
      >
        {collection?.description}
      </p>
      {collection?.description?.length > 140 ? (
        <p
          className={[
            'h-fit cursor-pointer',
            'font-display text-sm font-semibold text-accent hover:text-accent-light',
            !more ? 'pb-0' : 'pb-[1px]',
          ].join(' ')}
          onClick={() => setMore(!more)}
        >
          {!more ? <>More</> : <>Less</>}
        </p>
      ) : (
        <></>
      )}
    </div>
  );
}
